<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/industry/supplychain-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">汇通达商业布局</div>
      </div>
      <img src="@/assets/Mobile/images/industry/flex.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">上游供应链部分合作品牌图谱</div>
      </div>
      <img src="@/assets/Mobile/images/industry/brand.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">三大销售通路 商品直达会员店</div>
      </div>
      <img src="@/assets/Mobile/images/industry/goods.png" alt="">
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">品牌专场活动 商品营销活动 赋能商品</div>
      </div>
      <img src="@/assets/Mobile/images/industry/place.png" alt="">
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">平台418全国乡镇购物节</div>
        <div class="sub-title">8类线上活动、o2o活动500+场，参与会员店7万家</div>
      </div>
      <img class="image01" src="@/assets/Mobile/images/industry/holiday01.png" alt="">
      <img class="image02" src="@/assets/Mobile/images/industry/holiday02.png" alt="">
    </div>
    <div class="block06">
      <div class="sk-mobile-title">
        <div class="title">招商类目</div>
      </div>
      <img src="@/assets/Mobile/images/industry/category.png" alt="">
    </div>
    <div class="block07">
      <div class="sk-mobile-title">
        <div class="title">四大权益 共创共赢</div>
      </div>
      <img src="@/assets/Mobile/images/industry/right.png" alt="">
    </div>
    <Case title="供应链服务" />
    <ContactForm info-sources="供应链服务" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import Case from '@/Mobile/Mobilecom/Case'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'

export default {
  metaInfo: metaInfo.Supplychain,
  components: {
    Case,
    ContactForm
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  img {
    width: 344px;
    margin: 31px 0;
  }
}
.block02 {
  background-color: #FAFAFA;
  img {
    width: 336px;
    margin: 27px 0;
  }
}
.block03 {
  img {
    width: 333px;
    margin: 30px 0 13px 0;
  }
}
.block04 {
  background-color: #FAFAFA;
  img {
    width: 342px;
    margin-bottom: 15px;
  }
}
.block05{
  .image01 {
    width: 296px;
    margin-top: 20px;
  }
  .image02 {
    width: 296px;
    margin: 23px 0 32px 0;
  }
}
.block06 {
  background-color: #FAFAFA;
  img {
    width: 332px;
    margin: 20px 0 22px 0;
  }
}
.block07 {
  img {
    width: 345px;
    margin: 25px 0 18px 0;
  }
}
</style>
